import React from 'react'
import { Fragment } from 'react'
import ChatHeaderImage from './ChatHeaderImage'
import ChatHeaderStatus from './ChatHeaderStatus'
import ChatHeaderUser from './ChatHeaderUser'

function ChatHeader() {
    return (
        <Fragment>
            <div className="card-header">
                <div className="ticket-header col-12 pt-1">
                    <ChatHeaderImage />
                    <div className="ticket-detail col-11 pt-0 pb-0 mt-0 mb-0">
                        <div className="row justify-content-between pt-1">
                            <ChatHeaderUser />
                            <ChatHeaderStatus />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ChatHeader
